module.exports = __webpack_public_path__ + "static/media/YF95_5.1029ba5a.jpg";